import { render, staticRenderFns } from "./AccountItem.vue?vue&type=template&id=642cf2a4"
import script from "./AccountItem.vue?vue&type=script&lang=js"
export * from "./AccountItem.vue?vue&type=script&lang=js"
import style0 from "./AccountItem.vue?vue&type=style&index=0&id=642cf2a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports